/**
 * This file is created manually
 * You can change the content
 *
 */

import Typography from './typography/Typography'
export * from './typography/Typography'
export default Typography
